import { useContext } from "react";
import { AvisContext } from "../context/AvisContext";

export function NoDataPage(): React.JSX.Element {
  const { res } = useContext(AvisContext);

  return (
    <div className={"no-data-page"}>
      <p>{res("message_NoData")}</p>
    </div>
  );
}
